import React from 'react';
import { IconProps } from './model/IconInterface';

const WarehouseIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M3 21V9l9-6 9 6v12' />
        <path d='M3 21h18' />
        <rect x='8' y='13' width='8' height='8' />
        <line x1='12' y1='13' x2='12' y2='21' />
        <line x1='8' y1='17' x2='16' y2='17' />
    </svg>
);

export default WarehouseIcon;
